import base64 from 'base-64';

import { formatNumber } from '../../utils/formats';

const getKey = query => base64.encode(JSON.stringify(query));

const getPropertyOfKey = (state, key, property, defaultValue) => {
  if (state[key]) {
    return state[key][property];
  }
  return defaultValue;
};

/**
 * This function produces a combined reducer maintains state of an object list representation.
 */
const byList = (OBJECTS = undefined) => {
  if (OBJECTS === undefined) {
    throw new Error('Cannot create reducer, missing arguments');
  }

  return (state = {}, { meta, payload, type }) => {
    let key;
    if (meta) {
      key = getKey(meta.query);
    }

    switch (type) {
      case `FETCH_${OBJECTS}_PENDING`:
        return {
          ...state,
          [key]: {
            // Reset list starting a new request
            ids: meta.append ? getPropertyOfKey(state, key, 'ids', []) : [],
            // Reset when starting a new search
            details: meta.append ? getPropertyOfKey(state, key, 'details', {}) : {},
            error: null,
            fetched: (meta.append && meta.defaultFetchedBehaviour) ? getPropertyOfKey(state, key, 'fetched', false) : false,
            fetching: true,
            page: meta.append ? getPropertyOfKey(state, key, 'page', 1) : 1,
            // Reset when starting a new search
            total: meta.append ? getPropertyOfKey(state, key, 'total', 0) : 0,
          },
        };
      case `FETCH_${OBJECTS}_FULFILLED`:
        return {
          ...state,
          [key]: {
            // If append is set we're adding to a list
            ids: meta.append
              // Creating a set from concatenating two arrays remove any duplicates
              ? [...new Set(getPropertyOfKey(state, key, 'ids', []).concat((payload.results || []).map(obj => obj.id)))]
              : (payload.results || []).map(obj => obj.id),
            details: payload.searchDetails || {},
            error: null,
            fetched: true,
            fetching: false,
            page: getPropertyOfKey(state, key, 'page', 1) + 1,
            total: payload.total,
          },
        };
      case `FETCH_${OBJECTS}_REJECTED`:
        return {
          ...state,
          error: payload,
          fetched: true,
          fetching: false,
        };
      default:
        return state;
    }
  };
};

export default byList;

/**
 * Selectors
 */
export const getDetails = state => (state ? state.details : {});

export const getError = state => (state ? state.error : null);

export const getFetched = state => (state ? state.fetched : false);

export const getFetching = state => (state ? state.fetching : false);

export const getIds = state => (state ? state.ids : []);

export const getPage = state => (state ? state.page : 1);

export const getTotal = state => (state ? state.total : 0);

export const getTotalFormatted = state => (state ? formatNumber(state.total) : 0);



// WEBPACK FOOTER //
// ./app/src/state/reducers/byList.js